import React from 'react';
interface SectionHeadingProps {
  id: string;
  title: React.ReactNode;
  eyebrow?: string;
  lead?: React.ReactNode;
  tone?: 'light' | 'dark';
  align?: 'left' | 'center';
  className?: string;
}

/** Condensed industrial heading with an optional blue technical eyebrow. */
export function SectionHeading({
  id,
  title,
  eyebrow,
  lead,
  tone = 'dark',
  align = 'left',
  className = ''
}: SectionHeadingProps) {
  const dark = tone === 'dark';
  const centered = align === 'center';
  return <div className={`${centered ? 'mx-auto text-center' : ''} max-w-3xl ${className}`} data-id="element-130" data-mp="gjzr1i2awkmu">
      {eyebrow && <p className={`label-tech flex items-center gap-3 ${centered ? 'justify-center' : ''} ${dark ? 'text-arc-light' : 'text-[#0F6FD6]'}`} data-id="element-131" data-mp="1vbx1g83siz0">
          <span className="h-px w-6 shrink-0 bg-current" aria-hidden data-id="element-132" data-mp="uipowzwy2oc9" />
          {eyebrow}
        </p>}
      <h2 id={id} className={`font-heading text-[2.05rem] font-bold uppercase leading-[0.98] min-[390px]:text-[2.25rem] sm:text-[2.8rem] lg:text-[3.2rem] ${eyebrow ? 'mt-3' : ''} ${dark ? 'text-white' : 'text-ink'}`} data-id="element-133" data-mp="za7opkn8eivn">
        {title}
      </h2>
      {lead && <p className={`mt-4 text-[1rem] leading-relaxed sm:text-[1.08rem] ${centered ? 'mx-auto max-w-2xl' : 'max-w-2xl'} ${dark ? 'text-steel-pale' : 'text-graphite'}`} data-id="element-134" data-mp="230tvbqkb6si6">
          {lead}
        </p>}
    </div>;
}